import { Sidebar } from '../shared/Sidebar/Sidebar';
import { FC, useState } from "react";
import { Navbar } from "../shared/Navbar/Navbar";

export const AppLayout: FC<any> = (props): JSX.Element => {
    const { title, history, image, Component } = props;

    // Estado local para abrir/cerrar el sidebar
    const [visible, setVisible] = useState(false);

    return (
        <>
            <Navbar 
                visible={visible}
                setVisible={setVisible}
                title={title}
            />
            <Sidebar
                visible={visible}
                setVisible={setVisible}
                history={history}
                image={image}
            />
            <Component history={history} />
        </>
    );
};
